// extracted by css-extract-rspack-plugin
export default {"gridTemplateColumns":"_a4fa6ad3"};